// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading__jH39S","h1":"style__h1__sjKoI"};